import SinglePassStation from './SinglePassStation';

const AssemblageDS5Station = ({ userInfo, userPosition  }) => (
  <SinglePassStation
    userInfo={userInfo}
    userPosition={userPosition}
    stationName="Assemblage DS5"
    nextJobOnPass="Charging"
  />
);

export default AssemblageDS5Station;